<template>
<span class="ctrl-100 ctrl">
    <el-button class="ctrl-btn" :class="{active: timerFormVisible}" type="text" @click="toggleVisibility">
        <IconBase
            :height="32"
            :width="32"
            :view-box="`0 0 32 32`"
            :fill="room.timer?'#50C6DF':'#E7E6FA'"
            class="ctrl-icon"
        >
            <IconClock />
        </IconBase>
            <span :class="{active: room.timer}">Timer</span>
    </el-button>
    <div class="ctrl-window__overlay" v-if="timerFormVisible" @click="timerFormVisible = false"></div>
    <transition name="fade">
        <div class="ctrl-window" v-if="!room.timer && timerFormVisible" width="300px">
            <div class="ctrl__header">
                <h3 class="ctrl__title">Set Timer</h3>
                <div @click="timerFormVisible=false">
                    <IconBase
                        :height="24"
                        :width="24"
                        :view-box="`0 0 24 24`"
                        :fill="'#E7E6FA'"
                    >
                        <IconCross />
                    </IconBase>
                </div>
            </div>
            <el-form :model="timer" class="ctrl__form">
                <div class="stop-watch-form">
                    <div class="stop-watch-form-item">
                        <el-form-item>
                            <el-input-number :min="0" v-model="timer.hours" size="small"></el-input-number>
                        </el-form-item>
                        <span>
                            Hours
                        </span>
                    </div>
                    <div class="stop-watch-form-item">
                        <el-form-item>
                            <el-input-number :min="0" v-model="timer.minutes" size="small"></el-input-number>
                        </el-form-item>
                        <span>
                            Minutes
                        </span>
                    </div>
                </div>
            </el-form>
            <span class="ctrl__footer" slot="footer">
                <el-button @click="cancelStartTimer">Cancel</el-button>
                <el-button @click="timerFormVisible = false" type="primary" v-on:click="createTimer">Set</el-button>
            </span>
        </div>
    </transition>

    <transition name="fade">
        <div class="ctrl-window stop-timer-dialog" v-if="room.timer && timerFormVisible" width="20%">
            <div class="ctrl__header">
                <h3 class="ctrl__title"></h3>
                <div @click="timerFormVisible=false">
                    <IconBase
                        :height="24"
                        :width="24"
                        :view-box="`0 0 24 24`"
                        :fill="'#E7E6FA'"
                    >
                        <IconCross />
                    </IconBase>
                </div>
            </div>
            <div class="stop-timer__body">
                <div class="stop-timer-text">Do you want to stop the timer ?</div>
                <span class="ctrl__footer" slot="footer">
                    <el-button @click="timerFormVisible = false">Cancel</el-button>
                    <el-button @click="timerFormVisible = false" type="primary" v-on:click="deleteTimer">Stop Timer</el-button>
                </span>
            </div>
        </div>
    </transition>
</span>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import axios from '../../client'
import {
    mapState
} from "vuex";
import IconBase from '../IconBase'
import IconClock from '../icons/IconClock'
import IconCross from '../icons/IconCross'

export default {
    name: "Timer",
    components: {
        // eslint-disable-next-line vue/no-unused-components
        Icon,
        IconBase,
        IconClock,
        IconCross
    },
    data: function () {
        this.initialState = function () {
            return {
                timerFormVisible: false,
                timer: {
                    hours: 0,
                    minutes: 0
                }
            };
        }
        return this.initialState();
    },

    methods: {
        toggleVisibility(){
            this.timerFormVisible = !this.timerFormVisible
        },
        createTimer: async function () {
            this.timer.hours = this.timer.hours || 0;
            this.timer.minutes = this.timer.minutes || 0;
            try {
                await axios.post('/api/rooms/' + this.room._id + '/timer', {
                    duration: this.timer.hours * 3600 + this.timer.minutes * 60,
                    mainRoom: this.mainRoom.name
                })
                this.timer.hours = 0;
                this.timer.minutes = 0;
            } catch (err) {
                 if (err.response.data.message === "TOKEN_EXPIRED") {
                    this.$store.dispatch("user/refreshTokens", this.createTimer);
                } else {
                    alert(err)
                }
            }
        },

        deleteTimer: async function () {
            try {
                await axios.delete('/api/rooms/' + this.room._id + '/timer',{
                    data:{
                    mainRoom: this.mainRoom.name,
                    }
                })
            } catch (err) {
                 if (err.response.data.message === "TOKEN_EXPIRED") {
                     this.$store.dispatch("user/refreshTokens", this.deleteTimer);
                } else {
                    alert(err)
                }
            }
        },

        cancelStartTimer() {
            this.timerFormVisible = false;
            this.resetState();
        },

        resetState() {
            Object.assign(this.$data, this.initialState());
        }
    },
    computed: mapState({
        room: state => state.rooms.currentRoom,
        tokens: state => state.user.tokens,
        mainRoom: state => state.rooms.mainRoom
    })
}
</script>

<style>
.stop-timer-dialog .el-dialog__body {
    display: none;
}
</style>

<style scoped>
.stop-watch {
    fill: #F7F7F7;
}

.stop-watch:hover,
.active-timer {
    fill: #409EFF;
}

.stop-watch-form {
    display: flex;
    align-items: center;
    justify-content: center;
}

.stop-watch-form-item {
    display: inline-flex;
    flex-direction: column;
    padding: 0px 10px;
}

.el-form-item {
    margin-bottom: 5px;
}

.el-form-item+span {
    display: block;
    text-align: center;
}

.el-input-number--small {
    width: 120px;
}
.ctrl-icon {
    display: block;
}
.stop-timer__body {
    padding: 10% 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.stop-timer-text {
    font-size: 16px;
    line-height: 21px;
    margin-bottom: 20px;
}

>>>.el-input-number__decrease,
>>>.el-input-number__increase {
    border-radius: 50%;
    background-color: #393752;
    border: none;
}

span.active {
    color: #50C6DF;
}

button.ctrl-btn.el-button:hover span.active,
button.ctrl-btn.el-button.active span.active{
    color: #1C1C29;
}
</style>
